import { render } from "./liveturnoverPage.vue?vue&type=template&id=4540db5a"
import script from "./liveturnoverPage.vue?vue&type=script&lang=js"
export * from "./liveturnoverPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__